import React, { useState } from "react";
import Select from "react-select";
import "../styles/GetScoutedPage.scss";

const GetScoutedPage: React.FC = () => {
  const [step, setStep] = useState<"safety" | "age" | "form" | "digitals" | "success">("safety");
  const [formData, setFormData] = useState({
    ageRange: "",
    firstName: "",
    lastName: "",
    height: "",
    nationality: "",
    location: "",
    instagram: "",
    tiktok: "",
    guardianName: "",
    guardianEmail: "",
  });

  const [digitals, setDigitals] = useState({
    headshot: null as File | null,
    profile: null as File | null,
    fullLength: null as File | null,
  });

  const handleNextFromSafety = () => {
    setStep("age");
  };

  const handleAgeSubmit = () => {
    if (formData.ageRange) {
      setStep("form");
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (option: any) => {
    setFormData({ ...formData, ageRange: option ? option.value : "" });
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, type: "headshot" | "profile" | "fullLength") => {
    if (e.target.files && e.target.files[0]) {
      setDigitals({ ...digitals, [type]: e.target.files[0] });
    }
  };

  const handleSubmitForm = (e: React.FormEvent) => {
    e.preventDefault();
    setStep("digitals");
  };

  const handleSubmitDigitals = (e: React.FormEvent) => {
    e.preventDefault();
    // Here you'd send everything (e.g., EmailJS or Firebase logic)
    setStep("success");
  };

  const minAge = formData.ageRange ? parseInt(formData.ageRange.split("-")[0]) : 0;

  // Age options
  const ageOptions = [
    { value: "15-17", label: "15 - 17" },
    { value: "18-25", label: "18 - 25" },
    { value: "26-35", label: "26 - 35" },
    { value: "36-45", label: "36 - 45" },
    { value: "46-55", label: "46 - 55" },
    { value: "56-65", label: "56 - 65" },
    { value: "66-80", label: "66 - 80" },
  ];

  return (
    <div className="get-scouted-page">
      <div className="glass-box">
        {step === "safety" && (
          <>
            <h2>Safety First</h2>
            <p>
              Protecting aspiring models is our priority. Always verify emails and offers you receive. Never share personal info without confirmation.
            </p>
            <button onClick={handleNextFromSafety}>Acknowledge</button>
          </>
        )}

        {step === "age" && (
          <>
            <h2>Select Your Age Range</h2>
            <Select
              options={ageOptions}
              onChange={handleSelectChange}
              placeholder="Choose your age range"
              className="custom-select"
              classNamePrefix="react-select"
            />
            <button onClick={handleAgeSubmit} disabled={!formData.ageRange}>Next</button>
          </>
        )}

        {step === "form" && (
          <>
            <h2>Application Form</h2>
            <form onSubmit={handleSubmitForm}>
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="height"
                placeholder="Height (e.g., 5'9)"
                value={formData.height}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="nationality"
                placeholder="Nationality"
                value={formData.nationality}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="location"
                placeholder="Where do you live?"
                value={formData.location}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="instagram"
                placeholder="Instagram"
                value={formData.instagram}
                onChange={handleChange}
              />
              <input
                type="text"
                name="tiktok"
                placeholder="TikTok"
                value={formData.tiktok}
                onChange={handleChange}
              />
              {minAge < 18 && (
                <>
                  <input
                    type="text"
                    name="guardianName"
                    placeholder="Guardian Name"
                    value={formData.guardianName}
                    onChange={handleChange}
                    required
                  />
                  <input
                    type="email"
                    name="guardianEmail"
                    placeholder="Guardian Email"
                    value={formData.guardianEmail}
                    onChange={handleChange}
                    required
                  />
                </>
              )}
              <button type="submit">Next: Upload Digitals</button>
            </form>
          </>
        )}

        {step === "digitals" && (
          <>
            <h2>Submit Your Pictures</h2>
            <p className="upload-instructions">
              Please avoid wearing baggy clothing, makeup, or smiling. The photos you submit should not be filtered, retouched, or professionally taken.
            </p>
            <form onSubmit={handleSubmitDigitals}>
              <label>Upload Headshot</label>
              <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, "headshot")} required />
              <label>Upload Profile</label>
              <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, "profile")} required />
              <label>Upload Full Length</label>
              <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, "fullLength")} required />
              <button type="submit">Submit Application</button>
            </form>
          </>
        )}

        {step === "success" && (
          <>
            <h2>Thank you!</h2>
            <p>Your application and digitals have been received. We'll be in touch soon!</p>
          </>
        )}
      </div>
    </div>
  );
};

export default GetScoutedPage;
